import { samplePreProcessor } from "models/sample";

export const reviewSamplePreProcessor = (sn: any) => {
  return {
    ...sn,
    ...samplePreProcessor(sn),
    id: sn.id,
  }
}
